import { useContext } from "react";
import { WorkspaceType } from "../types";
import { Auth } from "../../../contexts/ridersUserContext";

export const useWorkspaces = () => {
  const { project } = useContext<any>(Auth.context);
  const tabs = {
    code: {
      closable: false,
      content: "",
      id: "0",
      isActive: true,
      isSaved: true,
      type: project.dev === "blockly" ? "blockly" : "python",
    },
    QA: {
      closable: false,
      id: "qa433",
      isActive: true,
      isSaved: true,
      title: "QA",
      type: "QA",
    },
    documentation: {
      closable: false,
      id: "n6mzwm",
      isActive: true,
      isSaved: true,
      title: "Documentation",
      type: "iframe",
      url: "https://d32lhafmwoak77.cloudfront.net/dev/docs/linerider/",
    },
    powerpoint: {
      closable: false,
      id: "n6mzadf",
      isActive: true,
      isSaved: true,
      title: "Powerpoint",
      type: "iframe",
      url: "https://d32lhafmwoak77.cloudfront.net/dev/docs/linerider/",
    },
    simulation: {
      closable: false,
      id: "ycqn01",
      isActive: true,
      isSaved: true,
      project: "lineridertest",
      title: "Linerider Test",
      type: "simulation",
    },
  };

  const getTabs = (tabType: WorkspaceType, path: string) => {
    const language = project.language;

    switch (tabType) {
      case "code":
        return {
          ...tabs.code,
          path: `${
            project.dev === "blockly"
              ? `blockly.xml`
              : language === "cpp"
              ? `/usercode/${path}.ino`
              : `/usercode/${path}.py`
          }`,
          title: `${
            project.dev === "blockly"
              ? "blockly.xml"
              : language === "cpp"
              ? `${path}.ino`
              : `${path}.py`
          }`,
        };
      case "documentation":
        return tabs.documentation;
      case "powerpoint":
        return tabs.powerpoint;
      case "simulation":
        return tabs.simulation;
      case "QA":
        return tabs.QA;
      default:
        break;
    }
  };

  return { tabs, getTabs };
};
